/* src/app/modules_v2/finance/entity-form/entity-form-dialog.scss */
.fe-header-text {
  min-width: 0;
  padding-right: 32px;
}
.fe-section + .fe-section {
  margin-top: 6px;
}
.fe-suffix {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
  margin-right: 6px;
}
.fe-load-error {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  font-size: 13px;
  color: #b91c1c;
}
.fe-load-error mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.fe-save-error {
  margin: 4px 0 0;
}
/*# sourceMappingURL=entity-form-dialog.css.map */
